// extracted by mini-css-extract-plugin
module.exports = {"expertDetails":"ExpertDetails_expertDetails__1Iw1s"};